export const STAT_TITLE_BANDS = [
  { level: 1, title: "Clueless", min: 0, max: 50 },
  { level: 2, title: "Incompetent", min: 51, max: 100 },
  { level: 3, title: "Capable", min: 101, max: 150 },
  { level: 4, title: "Novice", min: 151, max: 200 },
  { level: 5, title: "Competent", min: 201, max: 250 },
  { level: 6, title: "Proficient", min: 251, max: 300 },
  { level: 7, title: "Seasoned", min: 301, max: 400 },
  { level: 8, title: "Expert", min: 401, max: 500 },
  { level: 9, title: "Masterful", min: 501, max: 600 },
  { level: 10, title: "Virtuoso", min: 601, max: 750 },
  { level: 11, title: "Renowned", min: 751, max: 850 },
  { level: 12, title: "Legendary", min: 851, max: 1000 },
];

const TITLE_TO_LEVEL = Object.fromEntries(STAT_TITLE_BANDS.map((band) => [band.title, band.level]));

export function formatStatTitle(title, level) {
  if (!title) return "";
  const resolvedLevel = level || TITLE_TO_LEVEL[title];
  return resolvedLevel ? `${title} (Lvl ${resolvedLevel})` : title;
}
